import Cookie from 'cookie-universal';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const serverCookie = require('cookie-universal');

const TOKEN = 'loginApiToken';

function getPortalLoginToken(variables?: { req: Request; res: Response }) {
  let cookies = null;
  if (variables?.req && variables?.res) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    cookies = serverCookie(variables.req, variables.res);
  } else if (typeof window !== 'undefined') {
    cookies = Cookie();
  }

  return cookies ? cookies.get(TOKEN) || null : null;
}

export default getPortalLoginToken;
